import React from "react";
import tw from "twin.macro";
import styled from "styled-components";

const Container = tw.div`w-full mt-2 relative`;
const ProgressBarWrapper = tw.div`relative h-3 w-3/4 rounded-full bg-purple-300`;

const Progress = styled.div(({ percentage }) => [
  tw`h-full rounded-full bg-blue-600 transition-all duration-500 ease-in-out`,
  `width: ${percentage}%;`
]);

const Indicator = styled.div(({ percentage }) => [
  tw`absolute top-1/2 transform -translate-y-1/2 flex flex-col items-center text-white`,
  `left: calc(${percentage}% - 2.5rem);`
]);

const IndicatorValue = tw.div`bg-blue-600 border-2 border-white rounded-full px-1 mt-4 text-xs shadow-md whitespace-nowrap`;
const IndicatorDate = styled.div(({ color }) => [
  tw`mt-0 text-[0.65rem] font-semibold`,
  `color: ${color}`
]);
const MaxLabel = styled.div(({ color }) => [
  tw`absolute right-0 ml-1 -translate-y-4 flex justify-end text-xs`,
  `color: ${color}`
]);

const ProgressBar = ({ value = 3440, max = 12000, date = "8 Jun", textcolor = "black" }) => {
  const percentage = Math.min((value / max) * 100, 100);

  return (
    <Container>
      <ProgressBarWrapper>
        <Progress percentage={percentage} />
        <Indicator percentage={percentage}>
          <IndicatorValue>{value.toLocaleString('en-US')}</IndicatorValue>
          <IndicatorDate color={textcolor}>
            {
                new Date(date).toLocaleString('en-GB', {
                    day: 'numeric',
                    month: 'short'
                })
            }
          </IndicatorDate>
        </Indicator>
      </ProgressBarWrapper>
      <MaxLabel color={textcolor}>
        {max.toLocaleString('en-US')}
      </MaxLabel>
    </Container>
  );
};

export default ProgressBar;
